import { render, staticRenderFns } from "./StNewslettertogoSubscription.vue?vue&type=template&id=1c3e150e"
import script from "./StNewslettertogoSubscription.vue?vue&type=script&lang=ts"
export * from "./StNewslettertogoSubscription.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports